import { render, staticRenderFns } from "./DeleteCollection.vue?vue&type=template&id=50a2a266&scoped=true&"
import script from "./DeleteCollection.vue?vue&type=script&lang=js&"
export * from "./DeleteCollection.vue?vue&type=script&lang=js&"
import style0 from "./DeleteCollection.vue?vue&type=style&index=0&id=50a2a266&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a2a266",
  null
  
)

export default component.exports